import { Snackbar, Stack, Box, IconButton } from "@mui/material"
import { useState, useEffect } from "react"
import CloseIcon from '@mui/icons-material/Close'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ReportGenerationModal = (props: any) => {
  const { open, setOpen } = props

  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return
    }
    setOpen(false)
  }

  useEffect(() => {
    return () => {
      setOpen(false)
    }
  }, [])

  return (
    <Snackbar
      open={open}
      autoHideDuration={3000}
      onClose={handleClose}
      message={
        <Stack flexDirection={'row'} alignItems={'center'} gap={'12px'}>
          Журнал сформирован.
          <br />
          Для скачивания перейдите на вкладку "Медицинский журнал".
        </Stack>
      }
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      action={
        <Box>
          <IconButton
            size="small"
            aria-label="close"
            color="inherit"
            onClick={handleClose}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      }
    />
  )
}
